import { useCallback, useEffect, useRef } from "react";
import { buildLoginOptions, extractUrlParameters, useUnifiedAuth } from "../../unified-auth";

export default function Start() {
  const { loginWithAuth0, logout } = useUnifiedAuth();
  const isInitialized = useRef(false);

  const startUnifiedLogin = useCallback(async () => {
    if (isInitialized.current) {
      return;
    }
    isInitialized.current = true;

    const urlParams = new URLSearchParams(window.location.search);
    const prompt = urlParams.get("prompt") ?? undefined;

    // Only logout for prompt=login to force re-authentication
    if (prompt === "login") {
      try {
        await logout({ noRedirect: true });
      } catch (error) {
        console.error("Logout failed:", error);
      }
    }

    const params = extractUrlParameters(urlParams);
    const opts = buildLoginOptions(params);

    await loginWithAuth0(opts);
  }, [loginWithAuth0, logout]);

  useEffect(() => {
    startUnifiedLogin().then();
  }, [startUnifiedLogin]);

  return null;
}
